<div class="breadcrumb-area">
	<h1>Registro de Personal</h1>
</div>
<div class="card">
	<div class="card-body">
		<p class="h3">Administración de personal <span class="clickeable" (click)="showModalHiring()"> <i
					class="fa fa-circle-plus"></i> </span></p>
		<div class="table-responsive">
			<p class="h5">Personal a contratar</p>
			<p class="text-muted">
				<i class="fa fa-circle-info"></i>
				Para continuar con la contratación del personal, selecciona los empleados que desees contratar dandole
				click en el icono
				<i class="fa-regular fa-circle"></i> en el apartado de Acciones.
			</p>
			<ng-container *ngIf="personalToHire.length > 0">
				<table class="table" style="margin: 0;">
					<thead>
						<tr>
							<th class="td-center">Estado</th>
							<th class="td-center">ID</th>
							<th>Nombres</th>
							<th>Apellidos</th>
							<th class="td-center">Fecha Alta</th>
              				<th class="td-center">Fecha Baja</th>
							<th class="td-center">Genero</th>
							<th class="td-center">Fecha de nacimiento</th>
							<th class="td-center">Acciones</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let personal of pagination.filter"
							[ngClass]="personalHiring[personal.id]?'toHire':'clickeable'">
							<td class="td-center"><i [ngClass]="personal.active?'active':'opacity-50'"
									class="fa fa-power-off"></i></td>
							<td class="td-center">{{personal.identificacion}}</td>
							<td>{{personal.nombre}}</td>
							<td>{{personal.apellido}}</td>
							<td class="td-center">
								{{ personal.registerDate | date:'dd-MM-yyyy' }}
							</td>
							<td class="td-center">
								{{ personal.dischargeDate ? (personal.dischargeDate | date:'dd-MM-yyyy') : '-' }}
							</td>
							<td class="td-center">{{(personal.genero == 'H')?'Hombre':'Mujer'}}</td>
							<td class="td-center">{{personal.nacimiento | date:'dd-MM-YYYY'}}</td>
							<td class="td-center">
								<span class="clickeable" (click)="showModalEmployee(personal)">
									<i class="fa-regular fa-edit" tooltip="Editar información"></i>
								</span>
								<span class="clickeable" (click)="showModalDocuments(personal)">
									<i tooltip="Agregar documentos" class="fa-solid fa-file-circle-plus"></i>
								</span>
								<span (click)="addOrRemoveEmployee(personal)"
									[ngClass]="personalHiring[personal.id]?'toHire':'clickeable'" class="toHire">
									<i tooltip="Continuar contratación"
										[ngClass]="personalHiring[personal.id]?'fa fa-circle-check':'fa-regular fa-circle'"></i>
								</span>
							</td>
						</tr>
					</tbody>
				</table>
				<app-pagination-custom [elements]="pagination"></app-pagination-custom>
			</ng-container>
		</div>
		<ng-container *ngIf="personalToHire.length == 0">
			<span class="display-3"><i class="fa fa-circle-info"></i>No hay personal que falte por terminar el
				proceso, puedes contratar uno presionando <span (click)="showModalHiring()" class="clickeable">aquí</span></span>
		</ng-container>
		<button class="btn btn-info" *ngIf="!getDisabledHiring() && personalToHire.length>0" (click)="hiring = true"
			[disabled]="getDisabledHiring()" style="margin-top: 1em;">
			<span *ngIf="!hiring" class="notification-container"><i class="fa-solid fa-user"></i><span
					class="notification-icon" *ngIf="getHiringNumber()>0">{{getHiringNumber()}}</span></span>
			<span *ngIf="hiring" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
			CONTINUAR CON LA CONTRATACIÓN</button>
	</div>
</div>
<div class="card mt-1" *ngIf="hiring">
	<div class="card-body">
		<p class="h3">Finalizar Contrataciones</p>
		<div class="row">
			<div class="col-sm form-group">
				<label for="contractProfile" class="form-label">Perfil
					<i class="fa fa-circle-plus text-info clickeable" tooltip="Crea un perfil"
						(click)="showModalProfileSalary()"></i>
				</label>
				<div class="input-group">
					<select name="contractProfile" id="contractProfile" [(ngModel)]="selectedProfile"
						class="form-select">
						<option *ngFor="let contract of contractProfiles" value="{{contract.id}}">{{contract.name}}
						</option>
					</select>
					<button class="btn btn-info" tooltip="Ve el perfil actual" (click)="showActualProfileSalary()"><i
							class="fa fa-eye"></i></button>
				</div>
			</div>
			<div class="col-sm form-group">
				<label for="location" class="form-label">Ubicación
					<i class="fa fa-circle-plus text-info clickeable" tooltip="Crea una ubicación"></i></label>
				<select name="location" id="location" class="form-select">
					<option *ngFor="let warehouse of warehouses" value="{{warehouse.id}}">{{warehouse.name}}</option>
				</select>
			</div>
			<div class="col-sm form-group">
				<label for="area" class="form-label">Area
					<i class="fa fa-circle-plus text-info clickeable" tooltip="Crea un area"></i></label>
				<select name="area" id="area" class="form-select">
					<option *ngFor="let area of areas" value="{{area.id}}">{{area.name}}</option>
				</select>
			</div>
			<div class="col-sm form-group">
				<label for="area" class="form-label">Departamento
					<i class="fa fa-circle-plus text-info clickeable" tooltip="Crea un departamento"></i></label>
				<select name="area" id="area" class="form-select">
					<option *ngFor="let department of departments" value="{{department.id}}">{{department.name}}
					</option>
				</select>
			</div>
			<div class="col-sm form-group">
				<label for="position" class="form-label">Posición
					<i class="fa fa-circle-plus text-info clickeable" tooltip="Crea una posición"></i></label>
				<select name="position" id="position" class="form-select" [(ngModel)]="selectedPosition">
					<option *ngFor="let position of positions" value="{{position.id}}">{{position.name}}</option>
				</select>
			</div>
		</div>
	</div>
	<div class="card-footer mt-1" style="display: flex; justify-content: space-between;">
		<button class="btn btn-info" (click)="hiring = false">
			<i class="fa fa-ban"></i>CANCELAR</button>
		<button class="btn btn-success" [disabled]="!selectedPosition || !selectedProfile" (click)="contract()">
			<i *ngIf="!contractEmployees" class="fa fa-save"></i>
			<span *ngIf="contractEmployees" class="spinner-border spinner-border-sm"
				aria-hidden="true"></span>FINALIZAR</button>
	</div>
</div>
<app-modal-hiring *ngIf="newEmployee" [newEmployee]="newEmployee" [isCreating]="create" [citizenships]="citizenships"
	[contractProfiles]="contractProfiles" [countries]="countries" [departments]="departments" [towns]="towns"
	[warehouses]="warehouses" (close)="closingModalHiring()"></app-modal-hiring>
<app-modal-salary-profile *ngIf="newSalary" [newSalary]="newSalary" (close)="closeModalProfileSalary($event)"
	[isCreating]="createProfileSalary"></app-modal-salary-profile>
<app-modal-hiring-documents *ngIf="newDocuments" [newEmployee]="newDocuments"
	(close)="newDocuments = null"></app-modal-hiring-documents>